module.exports = __webpack_public_path__ + "static/media/servicos_electoral.9043ffe0.jpg";